var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27",
    "data-name": "Layer 27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,43.14H42.33V24.71a1,1,0,0,0-1-1H22.67a1,1,0,0,0-1,1V35.29H4a1,1,0,0,0-1,1V60a1,1,0,0,0,1,1H60a1,1,0,0,0,1-1V44.14A1,1,0,0,0,60,43.14ZM5,37.29H21.67V59H5ZM23.67,25.71H40.33V59H23.67ZM59,59H42.33V45.14H59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15,18.39a1,1,0,0,0,0,2h7.7a1,1,0,0,0,0-2H33V4a1,1,0,0,0-.66-.94,1,1,0,0,0-1.1.29L27.38,7.91A1,1,0,0,0,28.91,9.2L31,6.73V18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48,22.05a1,1,0,0,0,1-1c0-2.33,1.14-4,2.17-4H13c1,0,2.17,1.64,2.17,4A5.06,5.06,0,0,1,14,24.54L7.77,30.77a1,1,0,0,0,.71,1.71h7.71a1,1,0,1,0,0-2H10.9L15.43,26a7,7,0,0,0,1.76-4.9c0-3.34-1.83-6-4.17-6H11.65c-2.34,0-4.17,2.63-4.17,6A1,1,0,0,0,8.48,22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.62,38.63H47.36a1,1,0,0,0,0,2h5.26c1.93,0,3.45-2.13,3.45-4.85a5.64,5.64,0,0,0-1.35-3.85,5.66,5.66,0,0,0,1.35-3.85c0-2.72-1.52-4.85-3.45-4.85H47.36a1,1,0,0,0,0,2h5.26c.68,0,1.45,1.22,1.45,2.85s-.77,2.85-1.45,2.85H49.47a1,1,0,0,0,0,2h3.15c.68,0,1.45,1.22,1.45,2.85S53.3,38.63,52.62,38.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.ed840862464b90ce5b969f22f5650eaa.svg";
export { ForwardRef as ReactComponent };